// Fechas comerciales mexicanas que NO son festivos oficiales (no son días de
// descanso obligatorio) pero sí son grandes oportunidades de venta para
// micronegocios. Fechas exactas para 2026 y 2027.
// Las fechas móviles ya vienen calculadas:
//   - Buen Fin = tercer viernes de noviembre (2026: 20/11, 2027: 19/11)
//   - Día del Padre = tercer domingo de junio (2026: 21/6, 2027: 20/6)
// Las demás son fijas cada año.

export const FECHAS_COMERCIALES = [
  // --- 2026 ---
  { date: "2026-02-14", name: "San Valentín" },
  { date: "2026-03-08", name: "Día de la Mujer" },
  { date: "2026-04-30", name: "Día del Niño" },
  { date: "2026-05-10", name: "Día de las Madres" },
  { date: "2026-06-21", name: "Día del Padre" },
  { date: "2026-09-15", name: "Día de la Independencia" },
  { date: "2026-10-12", name: "Día de la Raza" },
  { date: "2026-11-01", name: "Día de Muertos" },
  { date: "2026-11-02", name: "Día de Muertos" },
  { date: "2026-11-20", name: "Buen Fin" },
  { date: "2026-11-20", name: "Día de la Revolución" },
  { date: "2026-12-25", name: "Navidad" },
  { date: "2027-01-01", name: "Año Nuevo" },

  // --- 2027 ---
  { date: "2027-02-14", name: "San Valentín" },
  { date: "2027-03-08", name: "Día de la Mujer" },
  { date: "2027-04-30", name: "Día del Niño" },
  { date: "2027-05-10", name: "Día de las Madres" },
  { date: "2027-06-20", name: "Día del Padre" },
  { date: "2027-09-15", name: "Día de la Independencia" },
  { date: "2027-10-12", name: "Día de la Raza" },
  { date: "2027-11-01", name: "Día de Muertos" },
  { date: "2027-11-02", name: "Día de Muertos" },
  { date: "2027-11-19", name: "Buen Fin" },
  { date: "2027-11-20", name: "Día de la Revolución" },
  { date: "2027-12-25", name: "Navidad" },
  { date: "2028-01-01", name: "Año Nuevo" },
];
